import Container from '@/components/templates/container'
import { urlForImage } from '@/sanity/lib/image'
import { useMediaQuery } from '@mui/material'
import Image from 'next/image'

const ImageSpacer = ({ image }) => {
  const base = 'aspect-[3/5] md:aspect-video'
  const isMobile = useMediaQuery('(max-width:767px)')

  return (
    <Container
      maxWidth={false}
      padding={false}
      outerClassName="mt-mediumDesktop lg:mt-largeDesktop"
      className={base}
    >
      {!isMobile && (
        <Image
          src={urlForImage(image.desktop).url()}
          alt={image.desktop.alt}
          fill
          placeholder="blur"
          blurDataURL={image.desktop.metadata.lqip}
          className="object-cover hidden md:block"
        />
      )}
      {isMobile && (
        <Image
          src={urlForImage(image.mobile).url()}
          alt={image.mobile.alt}
          fill
          placeholder="blur"
          blurDataURL={image.mobile.metadata.lqip}
          className="object-cover md:hidden"
        />
      )}
    </Container>
  )
}

export default ImageSpacer
